import moment from 'moment';

export const calculateDaysDiff = (start, end) => {
    let days = 1;
    let current = moment(start).startOf('day');
    let endDate = moment(end).startOf('day');
    while (current.isBefore(endDate)) {
        current.add(1, 'day');
        days++;
    }

    return days;
}

export const filterEventsForDate = (date, resource, events) => {
    return events.filter(event => {
        return (event.resourceId === resource.id || event.resourceId === null) && event.type !== 'Full Day';
    }).filter(event => {
        if (event.start.isSame(date, 'day')) {
            return true;
        }
        if (event.end.isSame(date, 'day')) {
            return true;
        }
        if (event.start.isBefore(date, 'day') && event.end.isAfter(date, 'day')) {
            return true;
        }
        return false;
    });
};

export const isEventEditable = (event) => {
    if (!event.type) {
        return true;
    }

    return editableTypes.includes(event.type);
};

export const editableTypes = [
    'Annual Leave',
    'Sickness',
    'Company Closed',
    'Bank Holiday',
];

export const isDateOnlyEventType = (type) => {
    return editableTypes.includes(type);
};

export const normalizeDateOnlyRange = (start, end) => {
    const startAt = moment(start).startOf('day');
    let endAt = moment(end).endOf('day');

    if (!startAt.isValid()) {
        return {};
    }

    if (!endAt.isValid() || startAt.isAfter(endAt, 'day')) {
        endAt = startAt.clone().endOf('day');
    }

    return {
        start_at: startAt,
        end_at: endAt,
    };
};



// WEBPACK FOOTER //
// ./resources/assets/js/include/Calendar.js